/* global localStorage */
import ApiService from '@/common/api.service'

import { FECTH_DB_TABLES, FECTH_DB_TABLE, FECTH_CHECK_BUILDER } from '@/store/actions.type'
import { SET_ERROR, SET_DB_TABLES, SET_DB_TABLE } from '@/store/mutations.type'

const state = {
    errors: null,
    db_tables: null,
}

const getters = {
    getDbTables(state) {
        return state.db_tables
    }
}

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error
    },
    [SET_DB_TABLES](state, db_tables) {
        state.db_tables = db_tables
        state.errors = {}
    }
}

const actions = {
    [FECTH_DB_TABLES](context, data) {
        if (this.db_tables) {
            return this.getDbTables()
        }
        return new Promise((resolve) => {
            ApiService
            .post('dashboard/show_db_table', data)
                .then((data) => {
                    context.commit(SET_DB_TABLES, data.data)
                    resolve(data.data)
                })
                .catch((data) => {
                    context.commit(SET_ERROR, data)
                })
        })
    },
    [FECTH_CHECK_BUILDER](context, data) {
        return new Promise((resolve) => {
            ApiService
            .post('dashboard/checkBuilder', data)
                .then((data) => {
                    resolve(data.data)
                })
                .catch((data) => {
                    context.commit(SET_ERROR, data)
                })
        })
    }
}

export default {
    state,
    mutations,
    getters,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/db_tables.js